module.exports = __webpack_public_path__ + "static/media/ONE-bg.218a1ede.svg";